export default __webpack_public_path__ + "static/media/fintro-logo-nl.49f9a6a4.svg";